import { IsOptional, IsUUID } from 'class-validator';

export class PriceCloneRequest {
    @IsOptional()
    @IsUUID()
    public priceTypeUuid?: string;

    constructor(data?: Partial<PriceCloneRequest>) {
        this.priceTypeUuid = data?.priceTypeUuid;
    }
}

